import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() enableSpinner: boolean = false;

  @Input() spinnerText: string = '';

  /**
   * When true the overlay covers the viewport (position: fixed) instead of just
   * its positioned ancestor. Use on tall / standalone pages (e.g. the setup
   * wizard) so the blur and loader stay centered in view regardless of scroll.
   */
  @Input() fullscreen: boolean = false;
}
